<template>
    <nav id="sidebar" class="sidebar sidebar-wrapper">
        <div class="sidebar-content">
            <h4 tabindex="0" class="text-white menu-header">Menú</h4>
            <div class="sidebar-brand"> </div>
            <div class="sidebar-menu">
                <ul id="js-navigation">
                    <li class="sidebar-dropdown linkactivo border-top">
                        <router-link to="/" class="link itemNavContenido">Elementos de contextualización</router-link>
                    </li>
                    <li class="sidebar-dropdown">
                        <a href="#"> Contenido<span class="icon-siguiente flechamenu float-right cerrado "
                                style="pointer-events: none;"></span> </a>
                        <div class="sidebar-submenu">
                            <ul>
                                <li class="sidebar-item">
                                    <router-link to="/accionProblemica" class="link itemNavContenido">Acción problémica</router-link>
                                </li>
                                <li class="sidebar-item"> 
                                    <router-link to="/conocimientosPrevios" class="link itemNavContenido">Conocimientos previos</router-link>
                                </li>
                                <li class="sidebar-dropdown">
                                    <router-link to="#" class="link">Tema 1</router-link>
                                    <div class="sidebar-submenu">
                                        <ul>
                                            <router-link to="/Tema1" class="link itemNavContenido">1. Elementos generales de la psicolingüística y naturaleza del lenguaje</router-link>
                                            <router-link to="/Tema1_1.1" class="link itemNavContenido">1.1. Aspectos históricos de la psicolingüística</router-link>
                                            <router-link to="/Tema1_1.2" class="link itemNavContenido">1.2. Marco general de la psicolingüística y la adquisición del lenguaje</router-link>
                                            <router-link to="/Tema1_1.3" class="link itemNavContenido">1.3. Metodología psicolingüística</router-link>
                                        </ul>
                                    </div>
								</li>
                                <li class="sidebar-dropdown">
                                    <router-link to="#" class="link">Tema 2</router-link>
                                    <div class="sidebar-submenu">
                                        <ul>
                                            <router-link to="/Tema2" class="link itemNavContenido">2. Teorías de adquisición del lenguaje</router-link>
                                            <router-link to="/Tema2_2.1" class="link itemNavContenido">2.1. Teoría ambientalista</router-link>
                                            <router-link to="/Tema2_2.2" class="link itemNavContenido">2.2. Teoría nativista</router-link>
                                            <router-link to="/Tema2_2.3" class="link itemNavContenido">2.3. Teoría del procesamiento</router-link>
                                            <router-link to="/Tema2_2.4" class="link itemNavContenido">2.4. Teorías cognitivas</router-link>
                                        </ul>
                                    </div>
								</li>
                               
                                 <li class="sidebar-item"> 
                                    <router-link to="/actividadSeguimiento" class="link itemNavContenido">Actividad de seguimiento</router-link>
                                </li>
                                <li class="sidebar-item"> 
                                    <router-link to="/autoEvaluacion" class="link itemNavContenido">Autoevaluación</router-link>
                                </li>
                                <li class="sidebar-item"> 
                                    <router-link to="/finUnidad" class="link itemNavContenido">Fin de la unidad</router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="sidebar-dropdown"> 
                        <router-link to="/referenciasBibliograficas" class="link itemNavContenido">Referencias bibliográficas</router-link>
                    </li>
                    <li class="sidebar-dropdown"> 
                        <router-link to="/creditos" class="link itemNavContenido">Créditos</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>


<script>

//Importamos la funcion navigation 
import {Navigation} from '../assets/RecursosITM/common/js/itm'

export default {
    name: 'Nav',
    mounted(){
        Navigation()
    }
}
</script>